'use strict';
'use es6';

// UIComponents runs in some environments where window.navigator is undefined.
// See: https://git.hubteam.com/HubSpot/hubspot-book-builder/pull/88

Object.defineProperty(exports, "__esModule", {
  value: true
});
var lowercasedUserAgent = window.navigator ? navigator.userAgent.toLowerCase() : '';

var isIE11 = exports.isIE11 = function isIE11() {
  return lowercasedUserAgent.includes('trident/');
};

var isEdge = exports.isEdge = function isEdge() {
  return lowercasedUserAgent.includes('edge/');
};

var isMS = exports.isMS = function isMS() {
  return isIE11() || isEdge();
};

var isFirefox = exports.isFirefox = function isFirefox() {
  return lowercasedUserAgent.includes('firefox');
};

var isSafari = exports.isSafari = function isSafari() {
  return lowercasedUserAgent.includes('safari/') && !isEdge();
};

var getEdgeVersion = exports.getEdgeVersion = function getEdgeVersion() {
  var match = lowercasedUserAgent.match(/edge\/(\d+)/);
  return match ? +match[1] : undefined;
};

var ignoresStyleTagInsertionOrder = exports.ignoresStyleTagInsertionOrder = function ignoresStyleTagInsertionOrder() {
  return isIE11() || isEdge() && getEdgeVersion() < 17;
};

/**
 * For faking `navigator.userAgent` in tests.
 * @param {string} newUserAgent
 */
var setUserAgent = exports.setUserAgent = function setUserAgent(newUserAgent) {
  lowercasedUserAgent = newUserAgent.toLowerCase();
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/utils/BrowserTest.js
// module id = 44
// module chunks = 171